














































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class MensajeValidacionHRef extends Vue {
  @Prop({ default: false }) showDialog!: boolean;
  @Prop({ default: '' }) titulo!: string;
  @Prop({ default: '' }) mensaje!: string;
  @Prop({ default: '' }) mensajeBot!: string;
  @Prop() href!: string;
  @Prop({ default: false }) btnCancelar!: boolean;
  @Prop({ default: "Ir a Histórico de informes"}) labelHref!: string;

  modalMensajeValidacion: boolean = false;

  @Watch('showDialog')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    this.modalMensajeValidacion = value;
  }

  handleCancelar(val: boolean) {
    this.$emit('btnCancelar', true);
    this.modalMensajeValidacion = false;
  }

  handleAceptar(val: boolean) {
    this.$emit('btnCancelar', true);
    this.$emit('modalConfirmationEmit', val);
    this.modalMensajeValidacion = false;
  }
}
